import { render, staticRenderFns } from "./Exercises.vue?vue&type=template&id=1f3c895e&scoped=true"
import script from "./Exercises.vue?vue&type=script&lang=js"
export * from "./Exercises.vue?vue&type=script&lang=js"
import style0 from "./Exercises.vue?vue&type=style&index=0&id=1f3c895e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c895e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3c895e')) {
      api.createRecord('1f3c895e', component.options)
    } else {
      api.reload('1f3c895e', component.options)
    }
    module.hot.accept("./Exercises.vue?vue&type=template&id=1f3c895e&scoped=true", function () {
      api.rerender('1f3c895e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Exercises.vue"
export default component.exports